var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/components/markdown-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["entry", "markdown_params"], 
[], 
function (l_entry, l_markdown_params, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", l_entry);
frame.set("markdown_params", l_markdown_params);
var t_2 = "";t_2 += "<!-- Markdown Component -->\n\n    <div class=\"s-cms\" data-qa-cms-markdown>\n\n        ";
if(l_markdown_params) {
t_2 += "\n\n            ";
t_2 += runtime.suppressValue(env.getFilter("markdown").call(context, env.getFilter("interpolate_values").call(context, runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"bodyText"),l_markdown_params)), env.opts.autoescape);
t_2 += "\n\n        ";
;
}
else {
t_2 += "\n\n            ";
t_2 += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.memberLookup((l_entry),"fields")),"bodyText")), env.opts.autoescape);
t_2 += "\n\n        ";
;
}
t_2 += "\n\n    </div>";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("markdownComponent");
context.setVariable("markdownComponent", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/components/markdown-component.j2"] , dependencies)